import { createContext } from 'reka-ui'
import { type useCustomFields } from '@gat-ship/custom-fields'

/**
 * Feature-local detail extras shared down the stakeholder detail tree. The
 * resolved data service itself is provided separately under `stakeholderKey`
 * (the `@gat-ship/types` contract); this carries the per-target custom-field
 * configuration that views, groups and edit modals all read.
 */
export interface StakeholderDetailContext {
  dynamicFields: ReturnType<typeof useCustomFields>
}

export const [useStakeholderDetail, provideStakeholderDetail] =
  createContext<StakeholderDetailContext>('gs-stakeholder-detail')
